<template>
  <div class="bread-crumb-container">
    <ul class="breadcrumb-list">
      <li class="breadcrumb-item"
        v-for="(breadcrumb,idx) in breadcrumbList"
        :key="idx"
        :class="{'linked': breadcrumb.link === undefined && breadcrumb.externalLink === undefined}">
          <span role="link" tabindex="0" @click="routeTo(idx)">{{ breadcrumb.name }}</span>
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        breadcrumbList: [],
      };
    },
    methods: {
      routeTo(path) {
        if (this.breadcrumbList[path].externalLink){
          window.location.href = this.breadcrumbList[path].externalLink;
        }
        else if (this.breadcrumbList[path].link){
          this.$router.push(this.breadcrumbList[path].link);
        }
      },
      updateList () { 
        this.breadcrumbList = this.$route.meta.breadcrumb;
      }
    },
    mounted () { 
      this.updateList();
    },
    watch: { 
      '$route'() { 
        this.updateList();
       } 
    },
  }
</script>